import React from 'react'
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Modal from 'src/components/theme/Models/Modal'
import { useEeocContext } from 'src/pages/cat/candidates/Candidate/cards/EEOC/useEeoc'

const Viewer: React.FC = () => {
  const { candidate, modals: { viewer: { value, isOpen, toggle } } } = useEeocContext()
  if (value === undefined) {
    return null
  }
  const filename = `${String(candidate?.name?.last)}_${String(candidate?.name?.first)}_EEOC_Documents.pdf`
  return (
    <Modal
      title='EEOC Paperwork'
      isOpen={isOpen}
      toggle={() => toggle()}
      size='xl'
    >
      <ModalHeader toggle={() => toggle()}>
        EEOC Paperwork

      </ModalHeader>
      <ModalBody className='vh100'>
        <embed src={value} style={{ width: '100%', height: '100%' }} title={filename} />
      </ModalBody>
      <ModalFooter>
        <a className='btn btn-primary' href={value} download={filename}>Download</a>
      </ModalFooter>
    </Modal>

  )
}

export default Viewer
